import React, { useCallback, ChangeEvent } from "react";
import { observer } from "mobx-react-lite";
import { Radio, RadioGroup } from "@mui/material";

import { translationService } from "../../services/translation/TranslationService";
import "./ListOfChoices.scss";

export interface Choice {
  nameKey: string;
  value: string;
}

interface ListOfChoicesProps {
  id?: string;
  options: Choice[];
  select: (value: string) => void;
  instructionKey?: string;
  titleKey?: string;
  defaultChecked?: Choice["value"];
}

export default observer(function ListOfChoices(props: ListOfChoicesProps) {
  const { id, instructionKey, titleKey, options, select, defaultChecked } = props;

  const check = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      select(e.target.value);
    },
    [select]
  );

  return (
    <div id={id} className="list-of-choices">
      <h3>{instructionKey && translationService.translate(instructionKey)}</h3>
      {titleKey && <h5>{translationService.translate(titleKey)}</h5>}
      <RadioGroup className="list-options">
        {options.map((option) => (
          <span>
            <Radio
              key={option.value}
              name={instructionKey}
              value={option.value}
              defaultChecked={!!defaultChecked && option.value === defaultChecked}
              onChange={check}
            />
            {translationService.translate(option.nameKey)}
          </span>
        ))}
      </RadioGroup>
    </div>
  );
});
